/* Vapurio COD theme — front-end logic.
   window.BRAND is defined in layout/theme.liquid from theme settings. */

/* brand text injection */
(function(){
  var B=window.BRAND||{};
  document.querySelectorAll('[data-brand]').forEach(function(e){e.textContent=B.name;});
  document.querySelectorAll('[data-brand-domain]').forEach(function(e){e.textContent=B.domain;});
  document.querySelectorAll('[data-brand-email]').forEach(function(e){e.textContent=B.email;});
})();

/* mobile menu (burger) */
(function(){
  var b=document.getElementById('burger'), m=document.getElementById('mobnav');
  if(!b||!m) return;
  function set(open){ b.setAttribute('aria-expanded',open?'true':'false'); if(open){m.removeAttribute('hidden');}else{m.setAttribute('hidden','');} }
  b.addEventListener('click',function(){ set(b.getAttribute('aria-expanded')!=='true'); });
  m.addEventListener('click',function(e){ if(e.target.tagName==='A') set(false); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') set(false); });
  window.addEventListener('resize',function(){ if(window.innerWidth>900) set(false); });
})();


/* "show more reviews" */
(function(){
  var btn=document.getElementById('moreReviews'), q=document.getElementById('quotes');
  if(!btn||!q) return;
  btn.addEventListener('click',function(){ q.classList.add('expanded'); btn.style.display='none'; });
})();

/* customer-photo lightbox */
(function(){
  var lb=document.getElementById('lightbox');
  var shots=[].slice.call(document.querySelectorAll('#photostrip .pshot'));
  if(!lb||!shots.length) return;
  var img=document.getElementById('lbImg'), txt=document.getElementById('lbTxt'), name=document.getElementById('lbName');
  var i=0;
  function render(){ var s=shots[i]; img.src=s.dataset.full; txt.textContent=s.dataset.txt?'„'+s.dataset.txt+'“':''; name.textContent=s.dataset.name+' · ověřený nákup'; }
  function open(idx){ i=idx; render(); lb.classList.add('open'); setTimeout(function(){lb.classList.add('show');},15); document.body.style.overflow='hidden'; }
  function close(){ lb.classList.remove('show'); setTimeout(function(){lb.classList.remove('open');document.body.style.overflow='';},280); }
  function go(d){ i=(i+d+shots.length)%shots.length; render(); }
  shots.forEach(function(s,idx){ s.addEventListener('click',function(){open(idx);}); });
  document.getElementById('lbX').addEventListener('click',close);
  document.getElementById('lbPrev').addEventListener('click',function(e){e.stopPropagation();go(-1);});
  document.getElementById('lbNext').addEventListener('click',function(e){e.stopPropagation();go(1);});
  lb.addEventListener('click',function(e){ if(e.target===lb) close(); });
  document.addEventListener('keydown',function(e){
    if(!lb.classList.contains('open')) return;
    if(e.key==='Escape') close(); if(e.key==='ArrowLeft') go(-1); if(e.key==='ArrowRight') go(1);
  });
})();

/* delivery estimate by region */
(function(){
  var sel=document.getElementById('regionSel');
  if(!sel) return;
  var DAYS=['neděle','pondělí','úterý','středa','čtvrtek','pátek','sobota'];
  var hoursEl=document.getElementById('dlHours'), s1=document.getElementById('dlStep1'),
      s2=document.getElementById('dlStep2'), s3=document.getElementById('dlStep3');
  function workday(d){ while(d.getDay()===0||d.getDay()===6){ d.setDate(d.getDate()+1); } return d; }
  function fmt(d){ return DAYS[d.getDay()]+' '+d.getDate()+'. '+(d.getMonth()+1)+'.'; }
  function update(){
    var h=parseInt(sel.value,10)||24;
    hoursEl.textContent=h;
    var now=new Date();
    // ordered today; ships within 24 h, then h hours to deliver
    var ship=workday(new Date(now.getTime()+24*3600*1000));
    var arrive=workday(new Date(ship.getTime()+h*3600*1000));
    s1.textContent='dnes '+fmt(now).split(' ')[0];
    s2.textContent=fmt(ship);
    s3.textContent=fmt(arrive)+' · do '+h+' h';
  }
  sel.addEventListener('change',update);
  update();
})();

/* before/after slider (homepage) */
(function(){
  var r=document.getElementById('baRange'), top=document.getElementById('baTop'), line=document.getElementById('baLine');
  if(!r||!top||!line) return;
  var set=function(v){ top.style.clipPath='inset(0 0 0 '+v+'%)'; line.style.left=v+'%'; };
  r.addEventListener('input',function(){ set(r.value); });
  set(50);
})();

/* header shadow on scroll */
(function(){
  var h=document.getElementById('hdr'); if(!h) return;
  addEventListener('scroll',function(){ h.classList.toggle('scrolled',scrollY>8); },{passive:true});
})();

/* stat-band counters (failsafe: final value already in HTML) */
(function(){
  if(!('IntersectionObserver' in window) || document.visibilityState==='hidden') return;
  var io=new IntersectionObserver(function(es){ es.forEach(function(en){
    if(!en.isIntersecting) return; io.unobserve(en.target);
    var el=en.target, end=+el.dataset.count, t0=performance.now(), dur=1200;
    (function tick(t){ var p=Math.min(1,(t-t0)/dur), e=1-Math.pow(1-p,3);
      el.textContent=Math.round(end*e).toLocaleString('cs-CZ');
      if(p<1) requestAnimationFrame(tick); else el.textContent=end.toLocaleString('cs-CZ'); })(t0);
  }); },{threshold:.4});
  document.querySelectorAll('[data-count]').forEach(function(el){ io.observe(el); });
})();

/* gallery crossfade (image-only; motion clips are animated WebP) */
(function(){
  var main=document.getElementById('gMain'), img=document.getElementById('gImg'), thumbs=document.getElementById('thumbs');
  if(!thumbs||!img) return;
  thumbs.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b) return;
    document.querySelectorAll('#thumbs button').forEach(function(x){x.classList.remove('on');});
    b.classList.add('on');
    main.classList.add('swap');
    setTimeout(function(){ img.src=b.dataset.src; img.onload=function(){main.classList.remove('swap');}; },180);
  });
})();

/* offer selection */
var codQty=1;
/* Money: formatted in the SHOP's currency using Shopify's own money_format,
   so the page can never show a different currency than the checkout charges.
   Input is always the Shopify integer amount (minor units, e.g. 229900). */
function fmt(cents){
  var f=(window.BRAND&&window.BRAND.moneyFormat)||'{{amount_with_comma_separator}} Kč';
  function num(dec,group,point){
    var s=(cents/100).toFixed(dec).split('.');
    s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,group);
    return s.join(point);
  }
  return f.replace(/\{\{\s*(\w+)\s*\}\}/g,function(_,k){
    if(k==='amount_no_decimals') return num(0,',','.');
    if(k==='amount_with_comma_separator') return num(2,'.',',');
    if(k==='amount_no_decimals_with_comma_separator') return num(0,'.',',');
    if(k==='amount_with_apostrophe_separator') return num(2,"'",'.');
    return num(2,',','.');
  }).replace(/<[^>]*>/g,'').trim();
}
function currentOffer(){ return document.querySelector('.offer.on'); }
function applyOffer(el){
  if(!el) return;
  document.querySelectorAll('.offer').forEach(function(o){o.classList.remove('on');o.querySelector('input').checked=false;});
  el.classList.add('on'); el.querySelector('input').checked=true;
  // Display strings come pre-rendered from Liquid (`money` filter) — never re-invented here.
  var p=+el.dataset.price, pf=el.dataset.priceF||fmt(p), wf=el.dataset.wasF||'';
  if(wf===pf) wf='';
  window.SELECTED_VARIANT=el.dataset.variant;
  window.SELECTED_SKU=el.dataset.sku;
  window.SELECTED_QTY=+el.dataset.qty;
  window.SELECTED_PRICE=p;
  var set=function(id,txt){ var e=document.getElementById(id); if(e) e.textContent=txt; };
  var pn=document.getElementById('priceNow');
  if(pn){ pn.textContent=pf; pn.classList.remove('bump'); void pn.offsetWidth; pn.classList.add('bump'); }
  set('priceWas',wf); set('navPrice',pf); set('mPrice',pf); set('mWas',wf);
  var skuEl=document.getElementById('skuNote');
  if(skuEl) skuEl.textContent=el.dataset.sku;
  // Releasit mode: keep the native product forms pointed at the selected offer
  document.querySelectorAll('[data-cod-vid]').forEach(function(i){ if(el.dataset.vid) i.value=el.dataset.vid; });
  document.querySelectorAll('[data-cod-qty]').forEach(function(i){ i.value=el.dataset.qty||1; });
  codQty=1; syncCod();
}
document.querySelectorAll('.offer').forEach(function(o){ o.addEventListener('click',function(){applyOffer(o);}); });
(function(){
  var pre=new URLSearchParams(location.search).get('varianta');
  var preEl=pre&&document.querySelector('.offer[data-variant="'+pre+'"]');
  applyOffer(preEl||document.querySelector('.offer'));
})();

/* Releasit safety net.
   The order buttons are native Shopify product forms so Releasit COD Form can bind to them.
   If the app embed is switched off (or the app fails to load) those forms would just dump the
   customer in /cart with no COD form at all. So we check at click time: no Releasit on the page
   -> cancel the submit and open the theme's own COD form instead. */
function releasitPresent(){
  if(window.Releasit||window.releasit||window.ReleasitCodForm) return true;
  if(document.querySelector('[id*="releasit" i],[class*="releasit" i],[data-releasit]')) return true;
  for(var i=0;i<document.scripts.length;i++){
    if(/releasit|cod-?form/i.test(document.scripts[i].src||'')) return true;
  }
  return false;
}
(function(){
  var forms=document.querySelectorAll('form.cod-appform');
  if(!forms.length) return;
  forms.forEach(function(f){
    f.addEventListener('submit',function(e){
      if(e.defaultPrevented) return;             // an app already took the submit over
      if(releasitPresent()) return;              // Releasit is live — let it do its thing
      e.preventDefault();
      openCodModal();
    });
  });
})();

/* COD modal */
var overlay=document.getElementById('codOverlay');
function syncCod(){
  var o=currentOffer(); if(!o||!overlay) return;
  var unit=+o.dataset.price;
  document.getElementById('cProdName').textContent=o.dataset.name;
  document.getElementById('cProdPrice').textContent=fmt(unit);
  document.getElementById('qVal').textContent=codQty;
  var total=unit*codQty;
  document.getElementById('tSub').textContent=fmt(total);
  document.getElementById('tTotal').textContent=fmt(total);
}
function openCodModal(){
  if(!overlay) return;
  syncCod();
  document.getElementById('codBody').style.display='block';
  document.getElementById('codSuccess').style.display='none';
  overlay.classList.add('open');
  setTimeout(function(){overlay.classList.add('show');},15);
  document.body.style.overflow='hidden';
}
if(overlay){
  document.querySelectorAll('[data-open-cod]').forEach(function(b){ b.addEventListener('click',openCodModal); });
  var closeCod=function(){
    overlay.classList.remove('show');
    setTimeout(function(){ overlay.classList.remove('open'); document.body.style.overflow=''; },280);
  };
  document.getElementById('codClose').addEventListener('click',closeCod);
  overlay.addEventListener('click',function(e){ if(e.target===overlay) closeCod(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeCod(); });
  document.getElementById('qMinus').addEventListener('click',function(){ if(codQty>1){codQty--;syncCod();} });
  document.getElementById('qPlus').addEventListener('click',function(){ if(codQty<9){codQty++;syncCod();} });

  /* submit -> COD webhook (Apps Script / server that creates the Shopify order) */
  document.getElementById('codForm').addEventListener('submit',function(e){
    e.preventDefault();
    var f=this, get=function(n){ return f.elements[n].value.trim(); };
    var ok=true;
    var rules={firstName:function(v){return v.length>1;}, lastName:function(v){return v.length>1;},
      phone:function(v){return /^[0-9 ]{9,}$/.test(v.replace(/[^0-9 ]/g,''))&&v.replace(/\D/g,'').length>=9;},
      street:function(v){return v.length>2;}, city:function(v){return v.length>1;}, zip:function(v){return /^\d{3}\s?\d{2}$/.test(v);}};
    Object.keys(rules).forEach(function(k){
      var fld=f.closest('.sheet-body').querySelector('.field[data-f="'+k+'"]');
      if(!rules[k](get(k))){ fld.classList.remove('bad'); void fld.offsetWidth; fld.classList.add('bad'); ok=false; }
      else fld.classList.remove('bad');
    });
    if(!ok) return;

    var o=currentOffer();
    var btn=document.getElementById('codSubmit');
    if(!btn.dataset.label) btn.dataset.label=btn.textContent;
    btn.disabled=true; btn.textContent='Odesílám…';
    var reset=function(){ btn.disabled=false; btn.textContent=btn.dataset.label; };
    var fail=function(){ alert('Odeslání se nepovedlo. Zkuste to prosím znovu.'); reset(); };

    // typed details -> attached to the Shopify order as attributes + note
    var attrs={
      'Jméno a příjmení': get('firstName')+' '+get('lastName'),
      'Telefon': '+420 '+get('phone'),
      'Adresa': get('street'),
      'Město': get('city'),
      'PSČ': get('zip'),
      'Nabídka': o.dataset.name,
      'Platba': 'Dobírka (COD)'
    };
    var vid=o.dataset.vid && parseInt(o.dataset.vid,10);
    var payload={source:'cod-form',brand:(window.BRAND&&window.BRAND.name),ts:new Date().toISOString(),
      product:o.dataset.name,variantId:vid||null,sku:o.dataset.sku||'',
      unitPrice:+o.dataset.price/100,qty:codQty,total:+o.dataset.price*codQty/100,
      currency:(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'CZK',
      payment:'Dobírka (COD)',customer:attrs};
    var showSuccess=function(){ document.getElementById('codBody').style.display='none'; document.getElementById('codSuccess').style.display='block'; reset(); };

    // Fallback route: cart -> Shopify checkout (customer picks Dobírka there).
    var viaCheckout=function(){
      if(!vid) return fail();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:vid,quantity:codQty}]})})
      .then(function(r){ if(!r.ok) throw 0;
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes:attrs, note:'Objednávka na dobírku (COD formulář)'})}); })
      .then(function(r){ if(!r.ok) throw 0; window.location.href=(window.routes&&window.routes.checkout)||'/checkout'; })
      .catch(fail);
    };

    // Preferred route: your COD endpoint creates the order with the Admin API and returns
    // { "redirect": "<order_status_url>" } — the customer lands straight on the thank-you page,
    // never seeing checkout. Endpoint must send CORS headers for this shop's domain.
    var hook=window.BRAND&&window.BRAND.orderWebhook;
    if(hook){
      fetch(hook,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(d){
          var url=d&&(d.redirect||d.order_status_url||d.orderStatusUrl);
          if(url){ window.location.href=url; return; }        // real Shopify thank-you page
          if(d&&d.ok){ showSuccess(); return; }               // order created, no URL returned
          viaCheckout();                                      // endpoint answered but gave us nothing usable
        })
        .catch(viaCheckout);                                  // endpoint down / CORS blocked
      return;
    }

    if(vid){ viaCheckout(); return; }

    console.log('COD ORDER (demo — no Shopify variant / webhook):',payload);
    setTimeout(showSuccess,700);
  });
}
